import { dls } from '@joinrepublic/dls-ui-core';

export const breakpoints = dls.breakpoints;
